/**
 * Coarse land outlines in [longitude, latitude] for Europe, North Africa, the Near East and North
 * America, projected with one flat cosine projection centred on 46° N so Europe and the USA carry
 * the same small shape error. Accurate to roughly half a degree to a degree, which is all a dot
 * map needs.
 */

type Ring = Array<[number, number]>

const EUROPE: Ring = [
    [-8.9, 37.0], [-7.4, 37.2], [-6.3, 36.8], [-5.6, 36.0], [-4.4, 36.7], [-2.1, 36.7], [-0.7, 37.6], [0.2, 38.8],
    [-0.3, 39.5], [0.9, 41.0], [3.2, 41.9], [3.1, 43.1], [4.5, 43.4], [6.6, 43.1], [7.5, 43.8], [8.7, 44.4],
    [10.2, 43.9], [11.1, 42.4], [12.6, 41.4], [14.0, 40.8], [15.6, 40.0], [15.9, 38.6], [15.6, 38.0], [16.6, 38.9],
    [17.1, 39.4], [18.5, 40.1], [18.0, 40.6], [16.0, 41.4], [16.1, 41.9], [14.1, 42.5], [13.6, 43.6], [12.3, 44.5],
    [12.4, 45.4], [13.7, 45.7], [13.6, 45.1], [14.4, 45.3], [15.3, 44.3], [16.5, 43.5], [18.5, 42.4], [19.5, 41.7],
    [19.4, 40.4], [20.0, 39.6], [21.1, 38.3], [21.6, 36.8], [22.5, 36.4], [23.0, 37.4], [23.7, 37.9], [24.0, 38.3],
    [22.8, 39.0], [22.6, 40.0], [22.9, 40.6], [24.0, 40.8], [26.0, 40.8], [26.2, 40.3], [27.0, 40.9], [29.0, 41.2],
    [28.0, 41.6], [27.9, 42.7], [28.6, 43.7], [29.7, 45.2], [30.8, 46.5], [31.9, 46.6], [33.6, 46.1], [33.4, 45.2],
    [36.0, 45.3], [35.4, 46.4], [38.2, 47.1], [39.5, 47.2], [45.0, 47.0], [45.0, 66.0], [41.0, 66.4], [40.0, 64.6],
    [37.0, 64.9], [35.0, 64.4], [34.8, 65.9], [33.0, 66.6], [35.0, 66.8], [38.5, 66.1], [41.0, 67.7], [41.0, 68.4],
    [37.0, 69.3], [33.0, 69.4], [31.0, 69.8], [28.5, 70.9], [26.0, 71.1], [23.5, 70.7], [21.0, 70.2], [18.5, 69.8],
    [16.0, 68.6], [14.5, 67.6], [13.0, 66.5], [12.3, 65.5], [10.8, 64.6], [9.5, 63.6], [7.0, 62.8], [5.0, 62.0],
    [5.0, 60.5], [5.3, 59.2], [5.6, 58.6], [7.0, 58.0], [8.5, 58.3], [10.2, 59.0], [10.6, 59.9], [11.2, 59.1],
    [11.8, 58.3], [12.0, 57.2], [12.8, 56.2], [13.0, 55.4], [14.3, 55.5], [14.5, 56.2], [16.0, 56.2], [16.6, 57.6],
    [16.5, 58.6], [17.9, 58.9], [18.8, 59.5], [18.0, 60.4], [17.3, 61.5], [17.5, 62.5], [19.0, 63.4], [20.7, 63.8],
    [21.5, 64.5], [22.3, 65.6], [24.5, 65.8], [25.4, 65.0], [24.6, 64.2], [22.4, 63.3], [21.4, 62.6], [21.6, 61.4],
    [21.4, 60.6], [22.5, 60.0], [24.5, 60.1], [26.6, 60.4], [28.5, 60.5], [30.0, 59.9], [28.1, 59.5], [26.0, 59.5],
    [23.5, 59.2], [23.5, 58.4], [24.4, 58.3], [24.1, 57.1], [23.0, 57.0], [21.3, 57.6], [21.0, 56.3], [21.1, 55.3],
    [20.0, 54.9], [19.4, 54.4], [18.6, 54.4], [17.5, 54.8], [16.0, 54.3], [14.2, 53.9], [12.5, 54.5], [11.0, 54.0],
    [10.8, 54.6], [9.9, 54.8], [10.4, 55.5], [10.6, 56.4], [10.4, 57.6], [9.9, 57.6], [8.6, 57.1], [8.1, 56.6],
    [8.1, 55.6], [8.6, 54.9], [8.9, 54.0], [8.0, 53.6], [7.0, 53.4], [5.8, 53.4], [4.8, 52.9], [4.2, 51.9],
    [3.3, 51.4], [2.5, 51.1], [1.6, 50.8], [1.5, 50.0], [0.2, 49.7], [-1.2, 49.4], [-1.9, 49.7], [-1.6, 48.6],
    [-3.0, 48.8], [-4.7, 48.6], [-4.3, 47.9], [-2.5, 47.3], [-2.2, 46.8], [-1.2, 46.0], [-1.3, 44.5], [-1.6, 43.4],
    [-3.5, 43.5], [-6.0, 43.6], [-8.0, 43.7], [-9.3, 43.0], [-8.9, 42.0], [-8.7, 41.0], [-9.4, 39.5], [-9.5, 38.8],
    [-8.8, 38.4]
]

const EUROPE_ISLANDS: Array<Ring> = [
    [[-24.5, 65.5], [-22.0, 66.4], [-18.5, 66.2], [-15.0, 66.5], [-13.5, 65.3], [-14.5, 64.4], [-18.0, 63.4], [-21.0, 63.8], [-22.7, 64.0], [-24.0, 64.9]],
    [[-10.4, 51.6], [-9.5, 53.3], [-10.0, 54.2], [-8.4, 55.2], [-6.2, 55.2], [-6.0, 53.9], [-6.0, 52.2], [-7.0, 52.1], [-8.5, 51.6]],
    [
        [-5.7, 50.1], [-3.0, 50.6], [0.0, 50.8], [1.4, 51.2], [1.7, 52.6], [0.3, 53.4], [-0.2, 54.1], [-1.5, 55.0], [-2.0, 55.9],
        [-3.0, 56.1], [-1.8, 57.6], [-3.3, 58.6], [-5.0, 58.6], [-6.2, 57.5], [-5.6, 56.4], [-5.0, 55.5], [-4.8, 54.8],
        [-3.4, 54.9], [-3.2, 54.2], [-3.1, 53.4], [-4.6, 53.3], [-4.2, 52.3], [-5.2, 51.7], [-3.2, 51.4], [-4.2, 51.2]
    ],
    [[11.0, 55.4], [12.6, 55.6], [12.4, 56.1], [11.3, 55.9]],
    [[9.7, 55.1], [10.8, 55.3], [10.5, 55.6], [9.9, 55.5]],
    [[18.1, 57.0], [18.9, 57.4], [18.6, 57.9], [18.2, 57.6]],
    [[12.4, 38.0], [15.6, 38.3], [15.1, 36.7], [13.2, 37.4]],
    [[8.2, 39.0], [9.6, 39.2], [9.8, 41.0], [8.3, 40.9]],
    [[8.6, 41.4], [9.4, 41.4], [9.5, 43.0], [8.6, 42.4]],
    [[23.5, 35.3], [26.3, 35.1], [26.0, 35.3], [24.0, 35.6]],
    [[22.0, 58.4], [23.3, 58.5], [22.8, 59.0], [22.2, 58.9]],
    [[32.3, 35.1], [33.0, 35.4], [34.6, 35.7], [34.0, 35.0], [32.9, 34.6]]
]

const AFRICA: Ring = [
    [-13.2, 8.5], [-14.6, 10.5], [-15.6, 11.6], [-16.8, 12.4], [-17.5, 14.7], [-16.5, 16.5], [-16.1, 18.2], [-16.5, 19.6],
    [-17.1, 20.8], [-16.4, 22.4], [-15.9, 23.7], [-14.8, 25.4], [-13.2, 27.3], [-12.0, 28.2], [-10.1, 29.3], [-9.7, 30.4],
    [-9.8, 31.5], [-9.1, 32.6], [-7.6, 33.6], [-6.8, 34.1], [-6.2, 35.3], [-5.9, 35.8], [-5.3, 35.9], [-4.4, 35.2],
    [-2.9, 35.3], [-1.2, 35.4], [-0.6, 35.8], [0.5, 36.3], [3.0, 36.8], [5.0, 36.8], [7.8, 37.0], [9.9, 37.3],
    [11.1, 37.1], [10.5, 36.3], [10.6, 35.8], [11.1, 35.2], [10.8, 34.7], [10.1, 33.9], [11.0, 33.5], [13.2, 32.9],
    [15.2, 32.4], [15.8, 31.5], [16.6, 31.2], [18.5, 30.3], [20.0, 30.9], [20.1, 32.1], [21.5, 32.9], [22.6, 32.8],
    [24.0, 32.1], [25.2, 31.6], [27.2, 31.4], [29.0, 30.9], [29.9, 31.2], [31.0, 31.6], [32.3, 31.3], [32.5, 30.0],
    [32.6, 29.3], [33.4, 28.0], [33.8, 27.2], [34.5, 25.6], [35.5, 23.9], [36.9, 22.0], [37.2, 19.6], [38.5, 18.0],
    [39.5, 15.6], [41.0, 14.0], [42.7, 13.0], [43.3, 11.6], [44.5, 10.4], [46.0, 10.6], [46.0, 2.0], [-12.0, 2.0]
]

const NEAR_EAST: Ring = [
    [29.0, 41.1], [31.2, 41.1], [32.6, 41.8], [34.0, 42.0], [35.2, 42.0], [36.0, 41.7], [37.5, 41.1], [39.0, 41.1],
    [40.5, 41.0], [41.6, 41.6], [41.4, 42.6], [40.0, 43.4], [38.8, 44.3], [37.5, 44.8], [36.7, 45.2], [37.3, 45.4],
    [38.2, 46.0], [38.3, 46.7], [39.6, 47.2], [46.0, 47.0], [46.0, 13.2], [45.0, 12.8], [43.4, 12.7], [42.8, 15.0],
    [42.6, 16.5], [41.2, 18.5], [39.6, 20.8], [39.1, 21.5], [38.1, 24.1], [36.6, 25.7], [35.2, 28.0], [35.0, 29.5],
    [34.3, 27.8], [32.6, 29.9], [32.3, 31.3], [33.8, 31.1], [34.4, 31.5], [34.8, 32.1], [35.0, 32.8], [35.5, 33.9],
    [35.8, 34.4], [35.9, 34.9], [35.8, 35.5], [35.9, 36.2], [36.2, 36.6], [35.6, 36.6], [35.0, 36.7], [34.6, 36.8],
    [33.9, 36.2], [32.8, 36.0], [32.0, 36.5], [30.7, 36.9], [30.4, 36.2], [29.6, 36.2], [29.1, 36.6], [28.3, 36.8],
    [27.4, 37.0], [27.2, 37.8], [26.8, 38.4], [26.3, 38.6], [26.7, 39.3], [26.1, 39.6], [26.4, 40.1], [27.5, 40.4],
    [28.9, 40.4], [29.9, 40.8]
]

const NORTH_AMERICA: Ring = [
    [-77.3, 8.7], [-78.4, 9.4], [-79.9, 9.4], [-81.2, 8.8], [-82.2, 9.2], [-83.0, 10.0], [-83.7, 11.0], [-83.7, 12.5],
    [-83.4, 14.0], [-83.2, 15.0], [-84.5, 15.9], [-86.0, 16.0], [-87.6, 15.8], [-88.6, 15.8], [-88.3, 17.5], [-88.0, 18.5],
    [-87.5, 19.6], [-86.8, 21.1], [-87.1, 21.6], [-88.5, 21.5], [-90.3, 21.1], [-90.5, 19.8], [-91.5, 18.5], [-93.0, 18.4],
    [-94.5, 18.1], [-96.1, 19.2], [-96.6, 20.2], [-97.3, 21.0], [-97.8, 22.3], [-97.7, 24.0], [-97.2, 25.9], [-97.3, 27.4],
    [-96.5, 28.3], [-95.0, 29.2], [-93.8, 29.7], [-92.0, 29.6], [-90.5, 29.1], [-89.2, 29.0], [-89.5, 30.2], [-88.1, 30.4],
    [-86.5, 30.4], [-85.4, 29.7], [-84.0, 30.0], [-83.0, 29.0], [-82.7, 27.8], [-81.8, 26.1], [-81.1, 25.2], [-80.4, 25.2],
    [-80.1, 25.9], [-80.0, 26.8], [-80.6, 28.5], [-81.0, 29.3], [-81.4, 30.4], [-81.1, 31.6], [-80.0, 32.6], [-78.9, 33.6],
    [-77.9, 33.9], [-76.6, 34.6], [-75.5, 35.2], [-75.9, 36.6], [-75.6, 37.8], [-75.1, 38.6], [-74.9, 38.9], [-74.1, 39.8],
    [-74.0, 40.6], [-71.9, 41.0], [-71.0, 41.5], [-70.0, 41.6], [-70.1, 42.0], [-70.9, 42.3], [-70.6, 43.0], [-70.2, 43.7],
    [-69.0, 44.1], [-67.8, 44.4], [-67.0, 44.8], [-66.0, 45.2], [-64.8, 45.8], [-64.5, 45.3], [-65.6, 44.7], [-66.2, 44.2],
    [-66.1, 43.8], [-65.4, 43.5], [-64.3, 44.3], [-63.6, 44.6], [-62.0, 45.0], [-61.0, 45.3], [-59.8, 46.0], [-60.4, 47.0],
    [-61.4, 46.4], [-62.5, 45.7], [-64.0, 46.2], [-64.7, 47.0], [-64.7, 47.8], [-65.6, 47.9], [-66.3, 48.0], [-65.3, 48.1],
    [-64.2, 48.8], [-65.0, 49.2], [-66.5, 49.1], [-68.3, 48.5], [-69.9, 47.4], [-71.2, 46.8], [-70.2, 47.5], [-69.5, 48.1],
    [-68.5, 49.0], [-67.2, 49.4], [-66.4, 50.2], [-64.0, 50.3], [-61.5, 50.2], [-59.5, 50.5], [-57.2, 51.4], [-55.8, 52.2],
    [-55.8, 53.4], [-57.3, 54.5], [-59.5, 55.2], [-61.2, 56.2], [-61.6, 57.5], [-62.6, 58.5], [-63.6, 59.6], [-64.5, 60.3],
    [-65.3, 59.8], [-66.4, 58.8], [-67.9, 58.3], [-69.3, 58.9], [-69.8, 60.1], [-70.2, 61.1], [-71.8, 61.4], [-73.8, 62.3],
    [-75.6, 62.3], [-77.5, 62.5], [-78.1, 61.6], [-77.7, 60.4], [-77.4, 59.4], [-76.6, 58.0], [-76.6, 56.6], [-77.5, 55.4],
    [-79.0, 54.5], [-78.8, 53.0], [-79.0, 51.6], [-80.2, 51.3], [-80.9, 52.0], [-82.2, 53.0], [-82.3, 55.1], [-85.0, 55.3],
    [-87.6, 56.0], [-89.3, 56.8], [-90.8, 57.2], [-92.6, 57.2], [-93.4, 58.4], [-94.3, 58.8], [-94.6, 59.8], [-94.4, 61.0],
    [-93.1, 61.9], [-91.4, 62.6], [-90.6, 63.4], [-88.4, 64.0], [-87.2, 64.8], [-86.7, 65.7], [-86.5, 66.5], [-84.2, 66.8],
    [-82.2, 67.8], [-81.6, 68.9], [-82.9, 69.7], [-84.9, 69.8], [-85.7, 68.8], [-87.2, 67.4], [-88.6, 68.2], [-89.7, 69.1],
    [-90.7, 70.2], [-91.6, 71.1], [-93.6, 72.0], [-95.1, 71.7], [-95.8, 70.4], [-95.4, 69.4], [-94.6, 68.9], [-95.6, 68.0],
    [-97.0, 67.7], [-98.8, 67.9], [-100.5, 67.8], [-102.5, 67.9], [-104.5, 68.1], [-106.5, 68.3], [-107.8, 68.9], [-108.8, 68.3],
    [-110.5, 67.9], [-112.8, 67.7], [-115.2, 67.9], [-114.4, 68.6], [-116.8, 69.0], [-119.0, 69.4], [-121.5, 69.8], [-123.6, 69.4],
    [-124.6, 70.1], [-126.2, 69.5], [-128.0, 70.2], [-129.8, 69.8], [-131.8, 69.6], [-133.5, 69.5], [-135.5, 69.2], [-137.5, 69.0],
    [-139.5, 69.5], [-141.0, 69.7], [-143.5, 70.1], [-146.0, 70.2], [-148.5, 70.4], [-151.0, 70.5], [-153.0, 70.9], [-155.5, 71.2],
    [-156.8, 71.3], [-158.5, 70.8], [-160.3, 70.4], [-162.0, 70.1], [-163.8, 69.2], [-166.0, 68.8], [-166.8, 68.3], [-165.0, 67.8],
    [-163.8, 67.3], [-162.5, 66.9], [-161.5, 66.4], [-163.5, 66.1], [-165.5, 66.2], [-168.0, 65.6], [-166.4, 64.6], [-164.5, 64.4],
    [-161.2, 64.6], [-160.9, 63.9], [-162.5, 63.4], [-164.4, 63.1], [-165.5, 62.3], [-165.6, 61.2], [-164.4, 60.5], [-162.4, 60.0],
    [-161.9, 59.0], [-160.3, 58.8], [-158.6, 58.8], [-157.3, 58.3], [-157.6, 57.3], [-159.0, 56.6], [-161.0, 56.0], [-163.2, 55.2],
    [-164.6, 54.6], [-163.0, 54.7], [-161.0, 55.2], [-159.0, 55.8], [-157.0, 56.6], [-155.5, 57.5], [-154.2, 58.4], [-152.5, 59.6],
    [-151.8, 59.2], [-150.0, 59.5], [-148.5, 60.0], [-146.5, 60.8], [-144.5, 60.2], [-142.0, 60.0], [-139.8, 59.6], [-138.0, 59.0],
    [-136.4, 58.2], [-135.4, 57.2], [-134.2, 56.2], [-132.6, 55.0], [-131.0, 54.6], [-130.4, 54.3], [-129.6, 53.2], [-128.6, 52.4],
    [-127.8, 51.2], [-127.9, 50.5], [-126.2, 49.6], [-125.1, 48.9], [-124.7, 48.4], [-124.1, 46.9], [-123.9, 46.2], [-124.1, 44.0],
    [-124.6, 42.8], [-124.2, 41.8], [-124.4, 40.4], [-123.8, 39.0], [-122.5, 37.8], [-121.9, 36.6], [-121.0, 35.6], [-120.6, 34.5],
    [-118.5, 34.0], [-117.2, 32.7], [-116.6, 31.6], [-115.8, 30.3], [-115.1, 27.9], [-114.3, 27.0], [-112.5, 25.8], [-111.8, 24.5],
    [-110.6, 23.5], [-109.9, 22.9], [-109.4, 23.5], [-110.3, 24.2], [-111.4, 26.0], [-112.4, 27.5], [-113.3, 28.9], [-114.2, 30.2],
    [-114.8, 31.8], [-113.1, 31.3], [-112.2, 29.4], [-111.0, 27.9], [-109.5, 26.4], [-108.4, 25.2], [-106.4, 23.2], [-105.4, 21.6],
    [-105.4, 20.4], [-104.3, 19.1], [-102.2, 17.9], [-99.9, 16.8], [-98.0, 16.1], [-96.5, 15.7], [-95.0, 16.2], [-93.5, 15.6],
    [-91.9, 14.4], [-89.6, 13.5], [-87.6, 13.2], [-86.6, 12.1], [-85.7, 11.0], [-85.8, 10.0], [-84.7, 9.6], [-83.6, 8.5],
    [-82.0, 8.2], [-80.4, 7.4], [-79.5, 8.9], [-78.4, 8.4], [-77.9, 7.2], [-77.4, 7.0]
]

const AMERICAN_ISLANDS: Array<Ring> = [
    [
        [-44.0, 59.8], [-43.0, 60.2], [-42.3, 61.5], [-41.0, 63.0], [-40.0, 64.4], [-37.6, 65.6], [-34.5, 66.4], [-32.0, 68.0],
        [-27.0, 68.5], [-23.5, 69.8], [-22.0, 71.0], [-22.0, 72.5], [-20.0, 74.0], [-19.0, 76.0], [-18.5, 78.0], [-20.0, 81.5],
        [-40.0, 83.5], [-60.0, 82.5], [-65.0, 81.0], [-68.0, 78.5], [-72.0, 77.8], [-70.0, 76.5], [-62.0, 76.0], [-58.5, 75.5],
        [-56.5, 73.8], [-55.5, 72.2], [-54.5, 70.8], [-53.5, 69.5], [-53.0, 68.0], [-53.7, 66.8], [-52.8, 65.5], [-51.7, 64.2],
        [-50.5, 63.0], [-49.0, 61.8], [-48.0, 60.9], [-45.5, 60.2]
    ],
    [
        [-64.8, 61.6], [-65.5, 62.8], [-64.0, 63.3], [-65.0, 64.6], [-63.5, 65.0], [-62.0, 66.0], [-61.5, 66.8], [-63.5, 67.4],
        [-65.0, 68.0], [-66.8, 69.1], [-68.5, 70.0], [-70.5, 70.8], [-72.0, 71.6], [-74.5, 72.3], [-77.5, 72.6], [-80.0, 73.6],
        [-84.0, 73.5], [-88.3, 73.5], [-89.5, 72.6], [-88.5, 71.2], [-85.0, 70.0], [-82.0, 69.8], [-79.5, 69.5], [-77.5, 68.5],
        [-74.5, 67.6], [-73.0, 66.8], [-74.0, 65.5], [-76.5, 65.3], [-78.0, 64.5], [-77.5, 63.7], [-75.0, 64.3], [-72.0, 63.0],
        [-70.0, 62.7], [-68.0, 62.3], [-66.5, 61.8]
    ],
    [[-87.0, 64.2], [-86.0, 65.3], [-84.5, 65.8], [-83.0, 65.2], [-81.5, 64.5], [-80.2, 63.8], [-81.5, 63.6], [-83.5, 64.0], [-85.5, 63.2], [-86.5, 63.6]],
    [
        [-101.5, 69.5], [-105.0, 69.1], [-108.5, 68.9], [-112.0, 69.1], [-115.5, 69.4], [-117.8, 69.9], [-118.8, 70.8], [-118.0, 72.0],
        [-115.0, 73.0], [-110.0, 73.2], [-106.5, 73.6], [-104.5, 73.0], [-102.0, 71.5], [-100.8, 70.3]
    ],
    [[-125.0, 71.9], [-123.5, 71.1], [-120.8, 71.4], [-117.5, 72.6], [-116.5, 73.6], [-119.5, 74.3], [-124.0, 74.3], [-125.9, 73.0]],
    [[-95.3, 72.0], [-93.0, 72.2], [-90.5, 73.0], [-90.2, 74.0], [-94.0, 74.1], [-95.5, 73.6]],
    [[-97.5, 71.7], [-96.0, 72.4], [-96.5, 73.6], [-98.5, 74.0], [-101.2, 73.4], [-100.5, 72.4], [-98.8, 71.9]],
    [[-80.0, 74.6], [-88.0, 74.5], [-92.0, 74.8], [-92.0, 76.2], [-88.0, 76.4], [-80.5, 76.0]],
    [[-105.5, 75.0], [-110.0, 74.6], [-115.0, 74.5], [-117.5, 75.5], [-114.0, 76.4], [-108.0, 76.3], [-105.5, 75.8]],
    [
        [-59.4, 47.6], [-56.0, 47.6], [-55.4, 46.9], [-53.7, 46.6], [-52.7, 47.5], [-53.3, 48.5], [-53.7, 49.3], [-55.4, 49.6],
        [-55.9, 51.6], [-57.3, 50.6], [-58.4, 49.3], [-59.3, 48.4]
    ],
    [[-154.7, 57.3], [-153.3, 58.0], [-152.2, 57.6], [-153.5, 56.8]],
    [[-133.0, 54.1], [-131.7, 54.0], [-131.0, 52.2], [-131.5, 52.0], [-132.5, 53.0]],
    [
        [-84.9, 21.9], [-83.0, 23.0], [-81.5, 23.2], [-80.0, 23.0], [-78.0, 22.3], [-76.0, 21.2], [-74.2, 20.2], [-75.5, 19.9],
        [-77.7, 19.8], [-77.2, 20.6], [-78.5, 21.5], [-80.5, 21.9], [-81.8, 22.2], [-83.5, 22.2]
    ],
    [[-74.4, 18.5], [-73.0, 19.9], [-70.0, 19.8], [-68.4, 18.6], [-69.8, 18.3], [-71.4, 17.6], [-72.8, 18.1], [-74.4, 18.0]],
    [[-78.4, 18.4], [-76.2, 18.2], [-76.8, 17.8], [-78.0, 18.0]],
    [[-67.3, 18.5], [-65.6, 18.4], [-65.7, 18.0], [-67.2, 18.0]],
    [[-155.9, 20.2], [-155.1, 19.9], [-154.8, 19.5], [-155.6, 18.9], [-156.1, 19.7]],
    [[-156.7, 21.0], [-156.0, 20.8], [-156.4, 20.6], [-156.7, 20.8]],
    [[-158.3, 21.6], [-157.7, 21.6], [-157.6, 21.3], [-158.1, 21.3]],
    [[-159.8, 22.2], [-159.3, 22.2], [-159.3, 21.9], [-159.7, 21.9]]
]

const LAND: Array<Ring> = [EUROPE, ...EUROPE_ISLANDS, AFRICA, NEAR_EAST, NORTH_AMERICA, ...AMERICAN_ISLANDS]

interface Box {
    west: number
    east: number
    south: number
    north: number
}

const BOXES: Array<Box> = LAND.map(ring => ({
    west: Math.min(...ring.map(point => point[0])),
    east: Math.max(...ring.map(point => point[0])),
    south: Math.min(...ring.map(point => point[1])),
    north: Math.max(...ring.map(point => point[1]))
}))

export const PROJECTION_COS = Math.cos((46 * Math.PI) / 180)

/**
 * Longitude and latitude to flat map units: one unit is one degree of latitude.
 */
export const project = (lon: number, lat: number): [number, number] => [(lon + 180) * PROJECTION_COS, 90 - lat]

export interface MapBounds {
    x0: number
    x1: number
    y0: number
    y1: number
}

const frame = (west: number, east: number, south: number, north: number): MapBounds => ({
    x0: project(west, north)[0],
    x1: project(east, south)[0],
    y0: project(west, north)[1],
    y1: project(east, south)[1]
})

export type AtlasRegion = 'europe' | 'usa'
export type AtlasViewKey = 'all' | AtlasRegion

export interface AtlasView {
    key: AtlasViewKey
    label: string
    name: string
    bounds: MapBounds
}

/**
 * The three frames the map flies between. Each one also grows to take in any marker of its region,
 * so a project added in Alaska or Hawaii stays in frame without touching these numbers.
 */
export const ATLAS_VIEWS: Array<AtlasView> = [
    { key: 'all', label: 'All', name: 'Europe and the USA', bounds: frame(-126, 38, 22, 71.5) },
    { key: 'europe', label: 'Europe', name: 'Europe', bounds: frame(-26, 34, 35, 71) },
    { key: 'usa', label: 'USA', name: 'the USA', bounds: frame(-126, -66, 23, 50) }
]

/**
 * Everything west of 40° W belongs to the American side of the map.
 */
export const regionOf = (lon: number): AtlasRegion => (lon < -40 ? 'usa' : 'europe')

const inside = (lon: number, lat: number, ring: Ring): boolean => {
    let hit = false

    for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
        const [xi, yi] = ring[i]
        const [xj, yj] = ring[j]

        if ((yi > lat) !== (yj > lat) && lon < ((xj - xi) * (lat - yi)) / (yj - yi) + xi) hit = !hit
    }

    return hit
}

export interface DotField {
    land: Float32Array
    coarse: Float32Array
    sea: Float32Array
    step: number
}

const FIELD = { west: -170, east: 45, south: 8, north: 76 }

let cached: DotField | null = null

/**
 * A regular grid of dots over the map: land dots inside the outlines (plus every other row and
 * column of them as a coarse set for small scales), and a sparse graticule over the sea.
 * Built once per session.
 */
export const getDotField = (): DotField => {
    if (cached) return cached

    const step = 0.45
    const land: Array<number> = []
    const coarse: Array<number> = []
    const sea: Array<number> = []
    const [x0, y0] = project(FIELD.west, FIELD.north)
    const [x1, y1] = project(FIELD.east, FIELD.south)
    let row = 0

    for (let y = y0; y <= y1; y += step, row++) {
        const lat = 90 - y
        const rows = LAND.filter((_, index) => BOXES[index].south <= lat && BOXES[index].north >= lat)
        const boxes = BOXES.filter(box => box.south <= lat && box.north >= lat)
        let column = 0

        for (let x = x0; x <= x1; x += step, column++) {
            const lon = x / PROJECTION_COS - 180
            const isLand = rows.some((ring, index) => lon >= boxes[index].west && lon <= boxes[index].east && inside(lon, lat, ring))

            if (isLand) {
                land.push(x, y)

                if (row % 2 === 0 && column % 2 === 0) coarse.push(x, y)
            }
            else if (row % 4 === 0 && column % 4 === 0) sea.push(x, y)
        }
    }

    cached = {
        land: new Float32Array(land),
        coarse: new Float32Array(coarse),
        sea: new Float32Array(sea),
        step
    }

    return cached
}
